import { IonCol, IonGrid, IonRow } from '@ionic/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import useAds from 'hooks/useAds';
import useAllShows from 'features/shows/hooks/useAllShows';
import AdComponent from 'components/Ads/AdComponent';
import BestMomentsSwiper from 'components/Eldo4RealSwiper';
import LoadingIndicator from 'components/LoadingIndicator';
import Carousel from 'components/Carousel';
import CardVertical from 'components/core/CardVertical';
import useResponsive from 'features/responsive/responsive';
import { Show } from 'types';
import clsx from 'clsx';
import PageLayout from '../components/PageLayout';
import 'swiper/css';
import Title from '../components/Title';
import Section from '../components/core/Section';
import { channels } from '../features/radio/constants';
import ChannelsSwiper from '../features/radio/component/ChannelSwiper';
import ChannelContent from '../features/radio/component/ChannelContent';


export default function RadioPage() {
    const [currentChannel, setCurrentChannel] = useState(channels[0]);
    const { ads } = useAds({ page: 'radio', reloadOnChangeString: currentChannel.title });
    const { t } = useTranslation();
    const { data: shows, isLoading } = useAllShows();
    const { IsMobile } = useResponsive();

    return (
        <PageLayout
            title={t('radio.title')}
            cssClass="radio-page"
        >
            <IonGrid fixed>
                {ads && <AdComponent ad={ads.data[0]} />}
                <IonRow className="md:mb-block mb-blockMobile">
                    <Title
                        main
                        title={t('radio.title')}
                        className="max-md:hidden"
                    />
                    <IonCol
                        size-xs={12}
                        className="md:mt-block-inner"
                    >
                        <ChannelsSwiper
                            currentChannel={currentChannel}
                            setCurrentChannel={setCurrentChannel}
                            channels={channels}
                        />
                    </IonCol>
                </IonRow>
                <Section>
                    <ChannelContent
                        channel={currentChannel}
                        slotAd={
                            ads ? (
                                <AdComponent
                                    hasSpacings={false}
                                    ad={ads.data[1]}
                                />
                            ) : null
                        }
                    />
                </Section>
                {isLoading ? (
                    <LoadingIndicator />
                ) : (
                    <Section
                        title={t('menu.shows')}
                        path="/radio/rubriken"
                        waveContainerProps={{
                            autoMargin: true,
                            fixed: 'block',
                            reverse: true,
                            position: 'bottom-left',
                            className: 'md:my-block my-blockMobile',
                            component: 'section',
                        }}
                    >
                        <Carousel<Show>
                            data={shows ?? []}
                            slidesPerView={IsMobile ? 1.45 : undefined}
                            className="!h-[110px]"
                        >
                            {(show) => (
                                <Link
                                    to={show.url ?? ''}
                                    className="block  w-full relative rounded-lg"
                                >
                                    <div className={clsx(
                                          "md:duration-300 md:hover:scale-[1.02] relative h-[105px] p-2",
                                          IsMobile ? "max-w-full" : "max-w-[250px]"
                                        )}>
                                        <CardVertical
                                            thumbnailUrl={show.imageUrl ?? ''}
                                            imgClassName="!h-[90px] max-h-[90px] object-cover w-full p-1 mx-auto"
                                            className="h-full overflow-y-hidden"
                                            hasWavePattern={false}
                                            hasCardHoverEffect={false}
                                            noPaddingOnHeader
                                        />
                                    </div>
                                </Link>
                            )}
                        </Carousel>
                    </Section>
                )}
                <Section
                    title={t('eldo4real')}
                    path="/podcast-replay/category/eldo4real"
                >
                    <BestMomentsSwiper />
                </Section>
                {/* TODO : next show (currently : missing data ??) */}
                {/* <Section title={t('next_show')}>
                    <RadioCard
                        src={`assets/img/webchannels/${'eldoradio.jpg'}`}
                        title={`${'test'}`}
                        liveStart={moment().format('HH:mm')}
                        liveEnd={moment().format('HH:mm')}
                        showRunner='Jean'
                        isVertical
                        displayWatchBtn={false}
                        displayPlayBtn={false}
                    />
                </Section> */}
                {ads && (
                    <AdComponent
                        hasSpacings={false}
                        ad={ads.data[2]}
                    />
                )}
            </IonGrid>
        </PageLayout>
    );
}
